document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (!toggle) return;
  const nav = document.querySelector('[data-mobile-nav]');
  if (!nav) return;
  const open = nav.toggleAttribute('data-open');
  toggle.setAttribute('aria-expanded', String(open));
});

document.addEventListener('input', (event) => {
  if (!event.target.matches('[data-imei]')) return;
  event.target.value = event.target.value.replace(/\D/g, '').slice(0, 15);
});

document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-variant-select]')) return;
  const option = event.target.options[event.target.selectedIndex];
  const price = event.target.closest('[data-product-form]')?.querySelector('[data-selected-price]');
  if (price && option.dataset.price) price.textContent = option.dataset.price;
});

document.addEventListener('submit', (event) => {
  const form = event.target.closest('[data-precheck]');
  if (!form) return;
  event.preventDefault();
  const service = form.querySelector('[data-service-choice]');
  const option = service.options[service.selectedIndex];
  const target = option.dataset.url || '/collections/all';
  const params = new URLSearchParams(new FormData(form));
  params.delete('service');
  window.location.assign(`${target}?${params.toString()}`);
});

document.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(window.location.search);
  document.querySelectorAll('[data-query-field]').forEach((field) => {
    const value = params.get(field.dataset.queryField);
    if (value) field.value = value;
  });
});
